<template>
  <svg class="icon mb-[3px] inline-block" viewBox="0 0 36 36" width="1em" height="1em">
    <path
      fill="#EF2B2D"
      d="M10 5H4a4 4 0 0 0-4 4v6h10zm22 0H16v10h20V9a4 4 0 0 0-4-4M10 31H4a4 4 0 0 1-4-4v-6h10zm22 0H16V21h20v6a4 4 0 0 1-4 4"
    ></path>
    <path fill="#002868" d="M14.5 5h-2.944l-.025 11.5H0v3h11.525L11.5 31h3V19.5H36v-3H14.5z"></path>
    <path
      fill="#EEE"
      d="M14.5 31H16V21h20v-1.5H14.5zM16 5h-1.5v11.5H36V15H16zm-4.5 0H10v10H0v1.5h11.5zM0 19.5V21h10v10h1.5V19.5z"
    ></path>
  </svg>
</template>
